/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	(function($){
	
		/**
		 * Copyright 2012, Digital Fusion
		 * Licensed under the MIT license.
		 * http://teamdf.com/jquery-plugins/license/
		 *
		 * @author Sam Sehnert
		 * @desc A small plugin that checks whether elements are within
		 *       the user visible viewport of a web browser.
		 *       only accounts for vertical position, not horizontal.
		 */
		$.fn.visible = function(partial,hidden,direction,container){
	
			if (this.length < 1)
				return;
	
			var $t          = this.length > 1 ? this.eq(0) : this,
							isContained = typeof container !== 'undefined' && container !== null,
							$w				  = isContained ? $(container) : $(window),
							wPosition        = isContained ? $w.position() : 0,
				t           = $t.get(0),
				vpWidth     = $w.outerWidth(),
				vpHeight    = $w.outerHeight(),
				direction   = (direction) ? direction : 'both',
				clientSize  = hidden === true ? t.offsetWidth * t.offsetHeight : true;
	
			if (typeof t.getBoundingClientRect === 'function'){
	
				// Use this native browser method, if available.
				var rec = t.getBoundingClientRect(),
					tViz = isContained ?
													rec.top - wPosition.top >= 0 && rec.top < vpHeight + wPosition.top :
													rec.top >= 0 && rec.top < vpHeight,
					bViz = isContained ?
													rec.bottom - wPosition.top > 0 && rec.bottom <= vpHeight + wPosition.top :
													rec.bottom > 0 && rec.bottom <= vpHeight,
					lViz = isContained ?
													rec.left - wPosition.left >= 0 && rec.left < vpWidth + wPosition.left :
													rec.left >= 0 && rec.left <  vpWidth,
					rViz = isContained ?
													rec.right - wPosition.left > 0  && rec.right < vpWidth + wPosition.left  :
													rec.right > 0 && rec.right <= vpWidth,
					vVisible   = partial ? tViz || bViz : tViz && bViz,
					hVisible   = partial ? lViz || rViz : lViz && rViz;
	
				if(direction === 'both')
					return clientSize && vVisible && hVisible;
				else if(direction === 'vertical')
					return clientSize && vVisible;
				else if(direction === 'horizontal')
					return clientSize && hVisible;
			} else {
	
				var viewTop 				= isContained ? 0 : wPosition,
					viewBottom      = viewTop + vpHeight,
					viewLeft        = $w.scrollLeft(),
					viewRight       = viewLeft + vpWidth,
					position          = $t.position(),
					_top            = position.top,
					_bottom         = _top + $t.height(),
					_left           = position.left,
					_right          = _left + $t.width(),
					compareTop      = partial === true ? _bottom : _top,
					compareBottom   = partial === true ? _top : _bottom,
					compareLeft     = partial === true ? _right : _left,
					compareRight    = partial === true ? _left : _right;
	
				if(direction === 'both')
					return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
				else if(direction === 'vertical')
					return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
				else if(direction === 'horizontal')
					return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
			}
		};
	
	})(jQuery);
	
	
	/***/ })
	/******/ ]);